<template>
    <modal :id="`delete-file-modal-${id}`">
        <template slot="body">
            <table class="table">
                <tbody>
                <tr>
                    <th>Name</th>
                    <td v-text="file.name"></td>
                </tr>
                <tr>
                    <th>Type</th>
                    <td v-text="file.type"></td>
                </tr>
                <tr>
                    <th>Size</th>
                    <td v-text="file.size"></td>
                </tr>
                <tr>
                    <th>Uploaded By</th>
                    <td v-text="file.user.name"></td>
                </tr>
                <tr>
                    <th>Uploaded Date</th>
                    <td v-text="shortDate(file.created_at)"></td>
                </tr>
                </tbody>
            </table>
        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal(`delete-file-modal-${id}`)">
                Cancel
            </button>
            <button class="btn btn-danger" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Delete</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Processing...</span>
            </button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            file: {
                type: Object,
                required: true,
            },
            id: {
                type: Number,
                required: false,
                default: '',
            }
        },

        data(){
            return {
                form: new Form({}),
            }
        },

        methods:{
            save(){
                this.form.delete(`/files/${this.file.id}`).then(response => {
                    this.closeModal(`delete-file-modal-${this.id}`)
                    this.$emit('deleted', this.file);
                })
            }
        },
    }
</script>
